var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 9.59999C8.42425 9.59999 8.83121 9.43142 9.13127 9.13136C9.43133 8.83131 9.5999 8.42434 9.5999 7.99999C9.5999 7.57565 9.43133 7.16868 9.13127 6.86862C8.83121 6.56857 8.42425 6.39999 7.9999 6.39999C7.57556 6.39999 7.16859 6.56857 6.86853 6.86862C6.56847 7.16868 6.3999 7.57565 6.3999 7.99999C6.3999 8.42434 6.56847 8.83131 6.86853 9.13136C7.16859 9.43142 7.57556 9.59999 7.9999 9.59999Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366455 7.99999C1.38566 4.75439 4.41765 2.39999 8.00005 2.39999C11.5825 2.39999 14.6145 4.75439 15.6337 7.99999C14.6145 11.2456 11.5825 13.6 8.00005 13.6C4.41765 13.6 1.38566 11.2456 0.366455 7.99999ZM11.2001 7.99999C11.2001 8.84869 10.8629 9.66262 10.2628 10.2627C9.66268 10.8629 8.84875 11.2 8.00005 11.2C7.15136 11.2 6.33743 10.8629 5.73731 10.2627C5.1372 9.66262 4.80006 8.84869 4.80006 7.99999C4.80006 7.1513 5.1372 6.33737 5.73731 5.73725C6.33743 5.13714 7.15136 4.79999 8.00005 4.79999C8.84875 4.79999 9.66268 5.13714 10.2628 5.73725C10.8629 6.33737 11.2001 7.1513 11.2001 7.99999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.ac0c81ea002dfc8aaabe9d1ecd24b41c.svg";
export { ForwardRef as ReactComponent };